// src/components/AuthContext.jsx

import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, firestore } from "../firebaseConfig";
import { mobileAuth } from "../mobileFirebaseConfig";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  getIdToken,
  signOut,
} from "firebase/auth";
import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const loginToMobileApp = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      mobileAuth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    console.error(error);
  }
};

export const logoutFromMobileApp = async () => {
  try {
    await signOut(mobileAuth);
  } catch (error) {
    console.error("Error logging out:", error);
  }
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch user data from Firestore
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = collection(firestore, "users");
        const q = query(docRef, where("email", "==", user.email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          const docRef = doc.ref;

          const unsubscribeSnapshot = onSnapshot(
            docRef,
            async (docSnapshot) => {
              if (docSnapshot.exists()) {
                const loggedInUser = await loginToMobileApp(
                  "spada@bnbgarage.com.tr",
                  "E^7;<CHps`rQ?*#TPZw%aU4Kg=LRf_.G[cDJ"
                );
                if (loggedInUser == null) {
                  console.error("Couldn't login to mobile app");
                  return;
                }
                setCurrentUser(docSnapshot.data());
                const authToken = await getIdToken(user);
                setAuthToken(authToken);
              } else {
                setCurrentUser(null);
                setAuthToken(null);
              }
              setLoading(false);
            }
          );

          // Cleanup the onSnapshot listener when the component unmounts or when the user changes
          return () => unsubscribeSnapshot();
          // biome-ignore lint/style/noUselessElse: <explanation>
        } else {
          setCurrentUser(null);
          setAuthToken(null);
          setLoading(false);
        }
      } else {
        setCurrentUser(null);
        setAuthToken(null);
        setLoading(false);
      }
    });

    // Cleanup the onAuthStateChanged listener when the component unmounts
    return () => unsubscribeAuth();
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
    await logoutFromMobileApp();
    setCurrentUser(null);
    setAuthToken(null);
  };

  return (
    <AuthContext.Provider
      value={{ currentUser, authToken, loading, signOut: handleSignOut }}
    >
      {children}
    </AuthContext.Provider>
  );
};
